const TwitterIcon = () => {
  return (
    // <svg xmlns="http://www.w3.org/2000/svg" width="22"
    // height="16" viewBox="0 0 512 512">
    //   <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
    // </svg>
    <img
    src="/images/header/twitter.png"
    alt="Twitter"
    width={20}
    height={20}
    style={{ cursor: "pointer" }}
  />
  );
};
const LinkedinIcon = () => {
  return (
    // <svg
    //   width="22"
    //   height="18"
    //   viewBox="0 0 25  15"

    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path d="M7.38045 15.7499H4.11514V5.23466H7.38045V15.7499ZM5.74604 3.80028C4.70189 3.80028 3.85498 2.93544 3.85498 1.8913C3.85498 1.38976 4.05422 0.908763 4.40886 0.554121C4.7635 0.19948 5.2445 0.000244141 5.74604 0.000244141C6.24757 0.000244141 6.72857 0.19948 7.08321 0.554121C7.43785 0.908763 7.63709 1.38976 7.63709 1.8913C7.63709 2.93544 6.78982 3.80028 5.74604 3.80028ZM19.6015 15.7499H16.3432V10.6311C16.3432 9.41122 16.3186 7.84677 14.6455 7.84677C12.9478 7.84677 12.6876 9.17216 12.6876 10.5433V15.7499H9.42584V5.23466H12.5576V6.66903H12.6033C13.0392 5.84286 14.1041 4.97099 15.6928 4.97099C18.9975 4.97099 19.605 7.14716 19.605 9.97372V15.7499H19.6015Z"/>
    // </svg>
    <img
    src="/images/header/linkedin.png"
    alt="LinkedIn"
    width={20}
    height={20}
    style={{ cursor: "pointer" }}
  />
  );
};


const FacebookIcon = () => {
  return (
    // <svg
    //   width="24"
    //   height="20"
    //   viewBox="0 0 24 14"
     
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M16.4185 10.125L16.9184 6.86742H13.7926V4.75348C13.7926 3.86227 14.2293 2.99355 15.6292 2.99355H17.0502V0.220078C17.0502 0.220078 15.7607 0 14.5278 0C11.9536 0 10.271 1.56023 10.271 4.38469V6.86742H7.40967V10.125H10.271V18H13.7926V10.125H16.4185Z"
    //   />
    // </svg>
    <img
    src="/images/header/facebook.png"
    alt="Facebook"
    width={20}
    height={20}
    style={{ cursor: "pointer" }}
  />
  );
};


const YouTubeIcon = () => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="24"
    //   height="24"
    //   viewBox="0 0 36 30"
    // >
    //   <g transform="translate(-507.5 -237.86)">
    //     <path
    //       d="M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z"
    //       // transform='translate(507.5 237.86)'
    //       className="bg transition"
    //     />
    //     <path
    //       d="M1019,4543.66c.9,0,1.82.02,2.71.06l1.06.05,1,.06.95.06.86.07a4,4,0,0,1,3.67,3.59l.04.45.08.95c.08.99.13,2.07.13,3.11s-.05,2.11-.13,3.1l-.08.95-.04.45a3.974,3.974,0,0,1-3.67,3.59l-.86.07-.94.07-1.01.05-1.06.06c-.9.03-1.81.05-2.71.06-.9-.01-1.81-.03-2.71-.06l-1.06-.06-1-.05-.95-.07-.86-.07a3.973,3.973,0,0,1-3.67-3.59l-.04-.45-.08-.95c-.08-1.03-.12-2.07-.13-3.1s.05-2.12.13-3.11l.08-.95.04-.45a4,4,0,0,1,3.67-3.59l.86-.07.94-.06,1.01-.06,1.06-.05C1017.19,4543.68,1018.1,4543.66,1019,4543.66Zm-2.1,5.85v5.09a.627.627,0,0,0,.94.55l4.41-2.55a.591.591,0,0,0,.24-.23.651.651,0,0,0,.08-.31.72.72,0,0,0-.08-.32.754.754,0,0,0-.24-.23l-4.41-2.54a.561.561,0,0,0-.31-.09.62.62,0,0,0-.32.09.631.631,0,0,0-.23.23.648.648,0,0,0-.08.31Z"
    //       transform="translate(-494 -4297)"
    //       className="i transition"
    //     />
    //   </g>
    // </svg>
    <img
    src="/images/header/youtube.png"
    alt="Youtube"
    width={20}
    height={20}
    style={{ cursor: "pointer" }}
  />
  );
};

const InstagramIcon = () => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="35"
    //   height="35"
    //   viewBox="0 0 35 35"
    // >
    //   <g transform="translate(-863.5 -4534.86)">
    //     {/* <path
    //       d="M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z"
    //       transform="translate(863.5 4534.86)"
    //       className="bg transition"
    //     /> */}
    //     <path
    //         d="M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z"
    //         transform="translate(863.5 4534.86)"
    //         fill="none"
    //       />
    //     <path
    //       d="M885.19,4542.36h-8.38c-3.64,0-5.81,2.17-5.81,5.81v8.37c0,3.65,2.17,5.82,5.81,5.82h8.37c3.64,0,5.81-2.17,5.81-5.81v-8.38C891,4544.53,888.83,4542.36,885.19,4542.36ZM881,4556.24a3.88,3.88,0,1,1,3.88-3.88A3.884,3.884,0,0,1,881,4556.24Zm5.92-9a.9.9,0,0,1-.54.54.99.99,0,0,1-1.09-.21,1.153,1.153,0,0,1-.21-.33.943.943,0,0,1,0-.76,1.035,1.035,0,0,1,.21-.33,1,1,0,0,1,.9-.27.616.616,0,0,1,.19.06.774.774,0,0,1,.18.09,1.624,1.624,0,0,1,.15.12,1.035,1.035,0,0,1,.21.33.943.943,0,0,1,0,.76Z"
    //       className="i transition"
    //     />
    //   </g>
    // </svg>
    <img
    src="/images/header/instagram.png"
    alt="Instagram"
    width={22}
    height={22}
    style={{ cursor: "pointer" }}
  />
  );
};

const  LoginIcon = () => {

  return (<svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    style={{ transform: 'rotate(-30deg)' }}
  >
    <path d="M12.804 9c1.038-1.793 2.977-3 5.196-3 3.311 0 6 2.689 6 6s-2.689 6-6 6c-2.219 0-4.158-1.207-5.196-3h-3.804l-1.506-1.503-1.494 1.503-1.48-1.503-1.52 1.503-3-3.032 2.53-2.968h10.274zm7.696 1.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z" />
  </svg>
  )
}

export { TwitterIcon, FacebookIcon, InstagramIcon, YouTubeIcon, LinkedinIcon, LoginIcon };
